import React from "react";
import SocialPostScreen, { SocialPostScreenProps } from "./SocialPostScreen";

const Step3: React.FC<SocialPostScreenProps> = (props) => {
  return <SocialPostScreen {...props} />;
};

export default Step3;
